import React from 'react';
import { Button, Upload, type UploadProps } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { selectToken } from '../../store/reducers/AuthSlice';
import { useAppDispatch, useAppSelector } from '../../store/store';
import { expireAuthSession } from '../../utils/http';
import { PROPS } from './constants';

type UploadChangeInfo = Parameters<NonNullable<UploadProps['onChange']>>[0];

export const isUnauthorizedUploadError = (file: UploadChangeInfo['file']) =>
  file.status === 'error' && file.xhr?.status === 401;

const AiTrainer: React.FC = () => {
  const token = useAppSelector(selectToken);
  const dispatch = useAppDispatch();

  const handleUploadChange: UploadProps['onChange'] = (info) => {
    PROPS.onChange?.(info);

    if (isUnauthorizedUploadError(info.file)) {
      expireAuthSession({ dispatch });
    }
  };

  const headers = {
    Authorization: `Bearer ${token}`,
    'Access-Control-Allow-Origin': '*',
  };

  return (
    <Upload {...PROPS} headers={headers} onChange={handleUploadChange}>
      <Button icon={<UploadOutlined />}>Загрузить</Button>
    </Upload>
  );
};

export default AiTrainer;
